export const BACKUPCODES = 'backupcodes';
export const DEVICEKEY = 'devicekey';
export const FIDOKEY = 'fidokey';
export const GENERATOR = 'generator';
export const PHONE = 'phone';
export const PUSH = 'push';
export const YUBIKEY = 'yubikey';
